import CantileverButton from 'components/CantileverButton'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import React from 'react'
import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const Title = styled.h3`
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 0.875rem;
  margin: 0;
`

const Subtitle = styled.p`
  color: ${({ theme }) => theme.forecast.secondaryText};
  font-size: 0.75rem;
  margin: 0;
`

const FilteredIndicator = styled.span`
  color: ${({ theme }) => theme.colors.success['400_base']};
  font-size: 0.75rem;
  font-weight: 500;
`

const FilteringIndicator = styled.span`
  color: ${({ theme }) => theme.forecast.warning};
  font-size: 0.75rem;
  font-weight: 500;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const PhotoCount = styled.span`
  color: ${({ theme }) => theme.forecast.secondaryText};
`

interface PhotoReelHeaderProps {
  photoCount: number
  totalPhotoCount: number
  isFiltered: boolean
  onClearFilter: () => void
}

export const PhotoReelHeader: React.FC<PhotoReelHeaderProps> = ({
  photoCount,
  totalPhotoCount,
  isFiltered,
  onClearFilter,
}) => {
  const { filteringPhotos } = useKestrelViewerContext()
  return (
    <Header>
      <LeftSection>
        <Title>Photo Reel</Title>
        {filteringPhotos ? (
          <FilteringIndicator>Filtering</FilteringIndicator>
        ) : isFiltered ? (
          <FilteredIndicator>Filtered</FilteredIndicator>
        ) : null}
        <Subtitle>Place Orbit to Filter</Subtitle>
      </LeftSection>
      <RightSection>
        <PhotoCount>
          {photoCount} photo{photoCount !== 1 ? 's' : ''}
          {isFiltered && ` of ${totalPhotoCount}`}
        </PhotoCount>
        {isFiltered && (
          <CantileverButton
            ghost
            onClick={onClearFilter}
            padding='0.25rem 0.5rem'
            textColor='inherit'>
            Show All
          </CantileverButton>
        )}
      </RightSection>
    </Header>
  )
}
